/* ============
 * Product Groups Index
 * ============
 *
 * This page shows the list of product groups.
 */

import { mapGetters, mapMutations } from 'vuex';
import priceFieldService from './../../../../services/priceField';
import SearchMixin from './../../../../mixins/search';
import debounce from 'debounce';

export default {
  data() {
    return {
      loading: false,
      sort: '',
    };
  },

  computed: {
    ...mapGetters({
      priceFields: 'paginatedPriceFields',
    }),
  },

  components: {
    VCard: require('./../../../../components/card/card.vue'),
    VPagination: require('./../../../../components/paginationNew/paginationNew.vue'),
    VNoData: require('./../../../../components/noData/noData.vue'),
  },

  mounted() {
   this.setInnerSidebar([
      {
        title: this.$t('static.products.filters.title'),
        options: [
          {
            title: this.$t('static.products.filters.latest'),
            route: {
              name: 'products.index',
              query: {
                filter: 'latest',
              },
            },
          },
          {
            title: this.$t('static.products.filters.pastMonth'),
            route: {
              name: 'products.index',
              query: {
                filter: 'pastMonth',
              },
            },
          },
          {
            title: this.$t('static.products.filters.all'),
            route: {
              name: 'products.index',
            },
          },
        ],
        button: {
          title: `+ ${this.$t('static.products.create.title')}`,
          route: {
            name: 'products.create',
          },
        },
      },
      {
        title: this.$t('static.productGroups.filters.title'),
        options: [
          {
            title: this.$t('static.productGroups.filters.latest'),
            route: {
              name: 'productGroups.index',
              query: {
                filter: 'latest',
              },
            },
          },
          {
            title: this.$t('static.productGroups.filters.pastMonth'),
            route: {
              name: 'productGroups.index',
              query: {
                filter: 'pastMonth',
              },
            },
          },
          {
            title: this.$t('static.productGroups.filters.all'),
            route: {
              name: 'productGroups.index',
            },
          },
        ],
        button: {
          title: `+ ${this.$t('static.productGroups.create.title')}`,
          route: {
            name: 'productGroups.create',
          },
        },
      },
      {
        title: this.$t('static.unitOfMeasure.filters.title'),
        options: [
          {
            title: this.$t('static.unitOfMeasure.filters.all'),
            route: {
              name: 'unitOfMeasure.index',
            },
          },
        ],
        button: {
          title: `+ ${this.$t('static.unitOfMeasure.create.title')}`,
          route: {
            name: 'unitOfMeasure.create',
          },
        },
      },
      {
        title: this.$t('static.priceFields.filters.title'),
        options: [
          {
            title: this.$t('static.priceFields.filters.all'),
            route: {
              name: 'priceFields.index',
            },
          },
        ],
        button: {
          title: `+ ${this.$t('static.priceFields.create.title')}`,
          route: {
            name: 'priceFields.create',
          },
        },
      },
    ]);
    this.all(1, 10);
  },

  destroyed() {
    this.unsetInnerSidebar();
  },

  watch: {
    /**
     * Listem to router changes, used to check query params that have changed to apply filters.
     *
     * @param  {Object} route Current route object.
     */
    $route() {
      this.all(1, 50);
    },
  },

  methods: {
    ...mapMutations({
      setInnerSidebar: 'SET_INNERSIDEBAR',
      unsetInnerSidebar: 'UNSET_INNERSIDEBAR',
    }),

    /**
     * Fetches paginated product groups.
     *
     * @param  {int} page The page number.
     * @param  {int} limit The number of items displayed per page.
     */
    all : debounce( function(page, limit = 10) {
      this.loading = true;
      priceFieldService.items({
        page,
        limit,
        search : this.getSearch(),
        filter : this.$route.query.filter
      })
      .then(() => {
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    }, 800),

    /**
     * Delete specific product group.
     *
     * @param  {Object} priceField The product group object.
     */
    deletepriceField(priceField) {
      this.$confirm(this.$t('static.priceFields.index.confirmDelete'), this.$t('static.priceFields.index.confirmDeleteTitle'), {
        confirmButtonText: this.$t('button.delete'),
        cancelButtonText: this.$t('button.cancel'),
        type: 'warning',
      }).then(() => {
        priceFieldService.destroy(priceField.id)
        .catch(({ response }) => {
          const message = response.data.error.code === 40114 ?
                          this.$t('static.priceFields.index.deleteHasProductError') :
                          this.$t('static.priceFields.index.deleteError');
          this.$message({
            showClose: true,
            message,
            type: 'error',
          });
        });
      }).catch(() => {

      });
    },

    /**
     * Go to edit view for product group.
     *
     * @param  {Object} priceField The product group object.
     */
    editpriceField(priceField) {
      this.$router.push({
        name: 'priceFields.edit',
        params: { id: priceField.id },
      });
    },

    goToProducts(id, e) {
      e.stopPropagation();
      this.$router.push({ name: 'products.index', query: { filter: `priceField,${id}` } });
    },
  },

  mixins: [
    SearchMixin,
  ],
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/priceFields/index/index.js